import { AfterViewInit, Component, Input } from '@angular/core';
import { LetterCellEditorBaseComponent } from '../letter-cell-editor-base/letter-cell-editor-base.component';

@Component({
    selector: 'se-letter-cell-editor-inline',
    templateUrl: './letter-cell-editor-inline.component.html',
    styleUrls: ['./letter-cell-editor-inline.component.scss']
})
export class LetterCellEditorInlineComponent extends LetterCellEditorBaseComponent implements AfterViewInit {

    @Input() startEdited: boolean;

    constructor() {
        super();
    }

    ngAfterViewInit(): void {
        if (this.startEdited) {
            this.formReady.emit(this.formControl);
            window.setTimeout(() => {
                this.initializeEditor();
            }, 0);
        }
    }

    private initializeEditor() {
        this.letterInput.nativeElement.focus();
        this.letterInput.nativeElement.select();
    }

}
